import { z } from 'zod';

import { BaseWidgetSchema } from './BaseWidgetSchema';
import { ProseMirrorJSONSchema } from './ProseMirrorJSONSchema';
import { WidgetType } from '../../utils/widgetsUtils';

export const EnclosureWithBlockTitleWidgetStaticSchema = BaseWidgetSchema(WidgetType.EnclosureWithBlockTitle).extend({
  textType: z.string(),
  /**
   * ProseMirror JSON
   */
  fragment: ProseMirrorJSONSchema,
  placeholder: z.string(),
  style: z.record(z.unknown())
});

export type EnclosureWithBlockTitleWidgetStaticSchemaType = z.infer<typeof EnclosureWithBlockTitleWidgetStaticSchema>;
